/**
 * Token Storage Utility
 * Manages JWT tokens in localStorage
 */

const ACCESS_TOKEN_KEY = 'accessToken';
const ID_TOKEN_KEY = 'idToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

export const tokenStorage = {
  /**
   * Store all tokens after login
   */
  setTokens(accessToken: string, idToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(ID_TOKEN_KEY, idToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  /**
   * Get access token (used for API requests)
   * Access token contains Cognito sub (UUID) which is used for authentication
   */
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  /**
   * Get ID token (contains user claims)
   */
  getIdToken(): string | null {
    return localStorage.getItem(ID_TOKEN_KEY);
  },

  /**
   * Get refresh token (used to get new access tokens)
   */
  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  /**
   * Clear all tokens (on logout)
   */
  clearTokens(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ID_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  /**
   * Check if user has valid tokens
   */
  hasTokens(): boolean {
    return !!this.getAccessToken();
  }
};
